module.exports = __webpack_public_path__ + "static/quiz4_question4-cba37fd723a8638ec132ecd4b7110d0b.jpg";